import React, { useEffect, useState, useContext } from 'react';
// @ts-ignore
import { PropTypes } from 'prop-types';
import { format } from 'date-fns';
import { Button, Modal, Table } from '@itds/elements';

import EditVersionDrawer from './ltc_quote_versions/Edit';
import { CarrierContext } from '@carrier/contexts/CarrierContext';

import Api from '@carrier/utils/Api';

const LtcQuoteVersions = ({ carrier }) => {
  const [versions, setVersions] = useState([]);
  const [version, setVersion] = useState(null);
  const { setNotification } = useContext(CarrierContext);
  const [modal, setModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);

  useEffect(() => {
    loadLtcQuoteVersions();
  }, []);

  const loadLtcQuoteVersions = action => {
    Api.loadLtcQuoteVersions(carrier.id)
      .then(({ data }) => {
        setVersions(data);
        if (action === 'save') {
          setNotification({
            message: 'Successfully Saved LTC Quote Version',
            type: 'success'
          });
        } else if (action === 'delete') {
          setNotification({
            message: 'Successfully Deleted LTC Quote Version',
            type: 'success'
          });
        } else if (action === 'add') {
          setNotification({
            message: 'Successfully Added LTC Quote Version',
            type: 'success'
          });
        }
      })
      .catch(() => {
        setTimeout(() => {
          if (action === 'save') {
            setNotification({
              message: 'Unable to save at this time',
              type: 'error'
            });
          } else if (action === 'delete') {
            setNotification({
              message: 'Unable to delete LTC Quote Version at this time',
              type: 'error'
            });
          } else if (action === 'add') {
            setNotification({
              message: 'Unable to add LTC Quote Version at this time',
              type: 'error'
            });
          }
        }, 2000);
      });
  };

  const handleCreate = () => {
    Api.createLtcQuoteVersion({ carrier_id: carrier.id }).then(() => {
      loadLtcQuoteVersions('add');
    });
  };

  const handleSave = () => {
    setVersion(null);
    loadLtcQuoteVersions('save');
  };

  const handleDelete = (obj, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);
    setModal(true);
    setDeleteInfo(obj);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);

    Api.deleteLtcQuoteVersion(deleteInfo.id)
      .then(() => {
        loadLtcQuoteVersions('delete');
        setModal(null);
        setDeleteInfo(null);
      })
      .catch(() => {
        setModal(null);
        setDeleteInfo(null);
      });
  };

  return (
    <>
      <EditVersionDrawer
        onClose={setVersion.bind(null, null)}
        onSave={handleSave}
        show={!!version}
        version={version}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button onClick={handleCreate}>New Version</Button>
      </div>

      <Table
        columns={[
          {
            id: 'id',
            label: 'ID'
          },
          {
            id: 'name',
            label: 'Name'
          },
          {
            id: 'created_at',
            label: 'Created',
            render: version => format(new Date(version.created_at), 'MM/dd/yyyy')
          },
          {
            id: 'updated_at',
            label: 'Updated',
            render: version => format(new Date(version.updated_at), 'MM/dd/yyyy')
          },
          {
            id: 'actions',
            render: row => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, row)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={versions}
        onRowClick={setVersion}
      />

      {modal ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${deleteInfo.name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{deleteInfo.name}"?
          </div>
        </Modal>
      ) : null}
    </>
  );
};

LtcQuoteVersions.propTypes = {
  carrier: PropTypes.object
};

export default LtcQuoteVersions;
